import {Component, Input, OnInit} from '@angular/core';
import {ExcRestService} from 'exc-rest-v2';
import {ExgModalService} from 'exc-controls-v2';
import {EnumerationService} from '../../../services/enumeration.service';
import {ExcTranslation} from 'exc-core-v2';

@Component({
  selector: 'app-modal-task-state-change-comment',
  templateUrl: './modal-task-state-change-comment.component.html',
  styles: [
  ]
})
export class ModalTaskStateChangeCommentComponent extends ExcTranslation implements OnInit {
  @Input() data: {
    taskState: number;
    enums: any[];
    isCancelOnly?: boolean;
  } = {taskState : 0, enums : []};
  textAreaRequired = false;
  private _selectedIndex = 0;

  get selectedIndex(): number {
    return this._selectedIndex;
  }
  set selectedIndex(index: number) {
    this._selectedIndex = index;
    this.updateTextAreaRequired(index);
  }
  stateChangeComment = '';

  constructor(public excRestService: ExcRestService, public modal: ExgModalService, public enumSvc: EnumerationService) {
    super();
  }

  ngOnInit(): void {
    this.selectedIndex = this.data.enums.map((a: any) => a.enmIdent).indexOf(this.data.taskState);
    if (this.data.isCancelOnly) {
      this.textAreaRequired = true;
    }
  }

  updateTextAreaRequired(index: number): void {
    const selectedEnmIdent = this.data.enums[index].enmIdent;
    this.textAreaRequired = (selectedEnmIdent === 9 || selectedEnmIdent === 12);
  }

  clickedSave(): void {
    /*Pflichtkommentar zu kurz*/
    const commentTooLongOrTooShort = (this.stateChangeComment.length < 10 || this.stateChangeComment.length > 1024);
    if (this.textAreaRequired && commentTooLongOrTooShort) {
      this.modal.showToast('Der Kommentar muss zwischen 10 und 1024 Zeichen lang sein.', 'md-toast', 'fas fa-exclamation');
      return;
    }
    /*Optionales Kommentar zu kurz*/
    if (this.stateChangeComment !== '' && commentTooLongOrTooShort) {
      this.modal.showToast('Der Kommentar muss zwischen 10 und 1024 Zeichen lang oder leer sein.', 'md-toast', 'fas fa-exclamation');
      return;
    }
    /*Alles in Ordnung*/
    this.modal.action({
      selectedStateEnmIdent: this.data.enums[this.selectedIndex].enmIdent,
      stateChangeComment: this.stateChangeComment
    });
    this.modal.close();
  }

  clickedCancel(): void {
    this.modal.close();
  }

}
